import { render, staticRenderFns } from "./ActionsLegacy.vue?vue&type=template&id=41c3cc73&"
import script from "./ActionsLegacy.vue?vue&type=script&lang=js&"
export * from "./ActionsLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports